import Overview from './overview'
import CustomerData from './customerData'
import TeamAudit from './teamAudit'
import Dispute from './dispute_request'
import CustomerSearch from './customerSearch'
import AllCustomers from './allCustomers'
import AllPortfolios from './allPortfolios'
import AllLoans from './allLoans'
import AllTransactions from './allTransactions'
import ErrorLogs from './errorLogs'

export default [
    Overview,
    CustomerData,
    TeamAudit,
    Dispute,
    CustomerSearch,
    AllCustomers,
    AllPortfolios,
    AllLoans,
    AllTransactions,
    ErrorLogs
]